import { render, staticRenderFns } from "./iRechargeBiz.vue?vue&type=template&id=11a0b9f2&scoped=true&"
import script from "./iRechargeBiz.vue?vue&type=script&lang=js&"
export * from "./iRechargeBiz.vue?vue&type=script&lang=js&"
import style0 from "./iRechargeBiz.vue?vue&type=style&index=0&id=11a0b9f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a0b9f2",
  null
  
)

export default component.exports